
import { ArrowRight } from "lucide-react";
import { Button, ContactButton } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const CallToActionSection = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-purple-50 to-indigo-50" aria-labelledby="cta-heading">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 id="cta-heading" className="text-3xl sm:text-4xl font-bold mb-6 text-gray-900">
            Ready to Contain the Security Chaos?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Schedule a consultation with our advisory team to discover how we can help your business move from security uncertainty to strategic advantage.
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <ContactButton 
              size="xl"
              className="bg-edgefi-purple text-white hover:bg-edgefi-purple/90 transition-colors px-8 py-6 h-auto shadow-lg hover:shadow-xl group"
              variant="cta"
              modalTitle="Cybersecurity Advisory Consultation"
              modalDescription="Tell us about your security challenges and let us guide you to clarity."
            >
              Begin Your Transformation
              <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </ContactButton>
            <Link to="/case-studies">
              <Button
                variant="outline"
                size="xl"
                className="border-purple-300 text-purple-700 hover:bg-purple-50 px-8 py-6 h-auto"
              >
                Explore Success Stories
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
